<script>
  import CreatorSpotlightModal from '@app-components/modal/CreatorSpotlightModal.svelte';
  import AccountVerifiedIcon from '@app-components/AccountVerifiedIcon.svelte';
  import { handleHrefLink } from '../utils/link-helpers';
  import Text from './Text.svelte';

  export let user = null;
  export let mobile = false;
  export let gotoProfile = false;
  export let size = null;
  let spotlightActive = false;
  let showSpotlightModal = false;

  let getSizeClassnames = function () {
    switch (size) {
      case 'typeface-h5':
       return 'typeface-h5'
      case 'typeface-h6':
       return 'typeface-h6'
      default:
        return 'typeface-h6'
    }
  };

  $: spotlightActive = user.spotlight_active;

  let handleClick = function (e) {
    if (!spotlightActive || gotoProfile) {
      handleHrefLink(e, user.profile_path);
    } else {
      e.stopPropagation();
      showSpotlightModal = true;
    }
  };

</script>

<style style="text/scss" lang="scss">
  @import '../vendor/design-system.scss';

  .display-name {
    cursor: pointer;
    color: $neutral-black;
    text-align: left;

    &:active {
      background: none;
    }

    &.typeface-h5 {
      @include typeface-h5($font-weight-medium);
    }

    &.typeface-h6 {
      @include typeface-h6($font-weight-medium);
    }
  }

  
</style>

{#if showSpotlightModal}
  <CreatorSpotlightModal
    mobile={mobile}
    user={user}
    bind:showModal={showSpotlightModal}
    on:close={() => {
      showSpotlightModal = false;
    }} />
{/if}

<div class="display-name {getSizeClassnames()}">
  <AccountVerifiedIcon dimension={16} verified={user.verified} on:areaClicked={handleClick}>
    <svelte:fragment slot="account-name">
      <Text lines={1} text={user.name} expand={false} />
    </svelte:fragment>
  </AccountVerifiedIcon>
</div>
